module.exports = __webpack_public_path__ + "img/upload_btn.fb156f1b.png";